<template>
  <form role="form" :aria-label="$t('common.security.certificate_form')">
    <fieldset>
      <legend class="sr-only">{{ $t('common.security.certificate_information') }}</legend>
      <b-row>
        <!-- CERTIFICAT -->
        <b-col sm="12" class="form-group" >
          <h3 v-if="!readonly">
            {{ $t('common.security.import_cert') }}
          </h3>
        </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="name" isMandatory
        :inputLabel="$t('common.security.cert_name')"
        inputId="cert-name">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.cert_name')"
        :inputValue="name">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="certificate" isMandatory
        :inputLabel="$t('common.security.certificate')"
        inputId="cert-certificate">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.certificate')"
        :inputValue="certificate">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <label for="security-type">
        {{ $t('common.type_label') }}<span class="color-red"> * </span>
      </label>
      <select class="form-control" v-model="type" id="security-type">
        <option value="0">{{ $t('common.security.please_select_a_type') }}</option>
        <option value="CA">{{ $t('common.security.ca') }}</option>
        <option value="SMIME">{{ $t('common.security.smime') }}</option>
        <option value="SSL">{{ $t('common.security.ssl') }}</option>
      </select>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.type_label')"
        :inputValue="type">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="3" class="form-group" v-if="!readonly">
      <datetime-picker-custom
        v-model="startDate"
        :disabled="readonly"
        format="DD/MM/YYYY H:i:s"
        :inputLabel="$t('common.security.valid_date')"
        customInputClass="form-control"
        customLabelClass="mb-0"
        :maxLength="19"
        :placeholderValue="'DD/MM/YYYY HH:mm:ss'"
        :descLabel="$t('common.datetime_format_help')"
        inputIcon="fa-solid fa-calendar pl-2"
        inputId="cert-start-date">
      </datetime-picker-custom>
    </b-col>
    <b-col sm="3" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.valid_date')"
        :inputValue="startDate">
      </form-read-group-label-input>
    </b-col>
    <b-col sm="3" class="form-group" v-if="!readonly">
      <datetime-picker-custom
        v-model="endDate"
        :disabled="readonly"
        format="DD/MM/YYYY H:i:s"
        :inputLabel="$t('common.security.unvalid_date')"
        customInputClass="form-control"
        customLabelClass="mb-0"
        :maxLength="19"
        :placeholderValue="'DD/MM/YYYY HH:mm:ss'"
        :descLabel="$t('common.datetime_format_help')"
        inputIcon="fa-solid fa-calendar pl-2"
        inputId="cert-end-date">
      </datetime-picker-custom>
    </b-col>
    <b-col sm="3" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.unvalid_date')"
        :inputValue="endDate">
      </form-read-group-label-input>
    </b-col>
    <b-col cols="4" class="form-group" v-if="this.formType !== 'add' && !readonly">
      <b-checkbox v-model="checkboxChangePass">{{ $t('common.chg_pwd') }}</b-checkbox>
    </b-col>
    <b-col cols="4" class="form-group" v-if="this.formType !== 'add' && !readonly">
      <b-checkbox v-model="checkboxShowPass">{{ $t('common.show_password') }}</b-checkbox>
    </b-col>
    <b-col v-if="this.formType !== 'add' && !readonly" cols="6"></b-col>
    <b-col sm="6" class="form-group" v-if="this.formType === 'add'">
      <form-write-group-label-input v-model="password"
        :inputLabel="$t('common.pwd')"
        :inputType="'password'"
        inputId="cert-password"
        :descLabel="$t('common.security.password_requirements')">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else-if="!readonly && checkboxChangePass === true">
      <form-write-group-label-input v-model="password"
        :inputLabel="$t('common.pwd')"
        :inputType="passwordFieldType"
        inputId="cert-password-edit"
        :descLabel="$t('common.security.password_requirements')">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="this.formType === 'add'">
      <form-write-group-label-input v-model="passwordVerif"
        :inputLabel="$t('common.security.verif_password')"
        :inputType="'password'"
        inputId="cert-password-verif">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else-if="!readonly && checkboxChangePass === true">
      <form-write-group-label-input v-model="passwordVerif"
        :inputLabel="$t('common.security.verif_password')"
        :inputType="passwordFieldType"
        inputId="cert-password-verif-edit">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-if="!readonly">
      <form-write-group-label-input v-model="cn" isMandatory
        :inputLabel="$t('common.security.cn')"
        inputId="cert-common-name">
      </form-write-group-label-input>
    </b-col>
    <b-col sm="6" class="form-group" v-else>
      <form-read-group-label-input
        :inputLabel="$t('common.security.cn')"
        :inputValue="cn">
      </form-read-group-label-input>
    </b-col>
      </b-row>
    </fieldset>
    
    <fieldset v-if="!readonly">
      <legend class="sr-only">{{ $t('common.security.pod_configuration') }}</legend>
      <b-row>
    <b-col sm="6" class="form-group">
      <label for="pod">
        {{ $t('common.security.pod') }}<span class="color-red"> * </span>
      </label>
      <select class="form-control" v-model="idPod" id="pod" :aria-label="$t('common.security.pod')">
        <option v-for="pod in podList" :key="pod.id" :value="pod.name">
          {{ pod.name }}
        </option>
      </select>
    </b-col>
      </b-row>
    </fieldset>
    
    <fieldset v-else>
      <legend class="sr-only">{{ $t('common.security.pod_configuration') }}</legend>
      <b-row>
    <b-col sm="6" class="form-group">
      <form-read-group-label-input
        :inputLabel="$t('common.security.pod')"
        :inputValue="idPod">
      </form-read-group-label-input>
    </b-col>
      </b-row>
    </fieldset>
  </form>
</template>
<script>
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import {errorMessageAlert} from '@/helpers/alert'
import { formatDateTime } from '@/helpers/format'
import moment from 'moment-timezone'

export default {
  name: 'CertificateFormGlobal',
  components: {
    'datetime-picker-custom': dateTimePicker,
    'form-read-group-label-input': formReadGroupLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'form-accordion': FormAccordion
  },
  props: {
    mode: {
      type: String,
      default: 'add'
    },
    placementCertificate: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name:{
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    certificate:{
      get () {
        return this.inputValue.certificate
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: val,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    type:{
      get () {
        return this.inputValue.type
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: val,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    startDate:{
      get () {
        return moment.tz(this.inputValue.startDate, this.timezone).format('DD/MM/YYYY HH:mm:ss')
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: formatDateTime(val),
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    endDate:{
      get () {
        return moment.tz(this.inputValue.endDate, this.timezone).format('DD/MM/YYYY HH:mm:ss')
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: formatDateTime(val),
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    password:{
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: val,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    passwordVerif:{
      get () {
        return this.inputValue.passwordVerif
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: val,
          cn: this.inputValue.cn,
          idPod: this.inputValue.idPod
        }
      }
    },
    cn:{
      get () {
        return this.inputValue.cn
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: val,
          idPod: this.inputValue.idPod
        }
      }
    },
    idPod:{
      get () {
        return this.inputValue.idPod
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          certificate: this.inputValue.certificate,
          type: this.inputValue.type,
          startDate: this.inputValue.startDate,
          endDate: this.inputValue.endDate,
          password: this.inputValue.password,
          passwordVerif: this.inputValue.passwordVerif,
          cn: this.inputValue.cn,
          idPod: val
        }
      }
    },
    pageTitle () {
      return this.$i18n.t('common.security.cert_info') + (this.placementCertificate + 1 > 0 ? (' ' + (this.placementCertificate)) : '')
    },
  },
  data () {
    return {
      checkboxChangePass: false,
      checkboxShowPass: false,
      formType: 'add',
      passwordFieldType : 'password',
      podList: [],
      timezone: '+00:00'
    }
  },
  created () {
    this.timezone = moment.tz.guess()
    this.formType = this.mode
    if (this.formType === 'create') {
      this.formType = 'add'
    }
    if (this.formType === 'add') {
      this.inputValue.startDate = moment.tz(moment(), this.timezone).format('YYYY-MM-DDTHH:mm')
      this.inputValue.endDate = moment.tz(moment(), this.timezone).format('YYYY-MM-DDTHH:mm')
    }
    if (this.formType === 'view') {
      this.inputValue.passwordVerif = this.value.password
    }
    this.getPods()
  },
  methods: {
    getPods () {
      let that = this

      this.$engine.firstOn().routing.pod.fetch()
      .then(resp => {
        let podsObject = {}
        podsObject = resp.data.Pods
        that.updatePods(podsObject)
        this.$f7.pullToRefreshDone()
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleVisibility () {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    updatePods (podsObject) {
      this.podList = podsObject
    }
  },
  watch: {
    checkboxChangePass () {
      if(this.checkboxChangePass === true) {
        this.inputValue.passwordVerif = ''
      } else {
        this.inputValue.passwordVerif = this.value.password
      }
    },
    checkboxShowPass () {
      this.toggleVisibility()
    }
  }
}
</script>